module["exports"] = ["Sr.", "Dr.", "Prof.", "Eng.º"];